import { parsePrice, type PriceInput } from '@/shared/utils/priceFormatter';
import { commonFacebookEventsUtil } from '@/shared/features/analytics/utils/facebookCommonAttributes';
import { getUserInfo } from '@/shared/features/analytics/utils/commonAttributes';

/**
 * Meta Pixel - AddToWishlist Event
 * Mirrors `facebookAddToWishlist()` from old-react eventLogger.js.
 */
export function facebookAddToWishlist(
  designId: number | string | null | undefined,
  designName: string | null | undefined,
  designCategory: string | null | undefined,
  price: PriceInput,
): void {
  const parsedPrice =
    price != null && price !== '' ? parsePrice(String(price)) : 0;

  // Retrieve latest updated userinfo/context cache for wishlist info
  const userInfo = getUserInfo();
  const wishListDesignIds = userInfo?.wishListDesignIds as number[] | undefined;

  // Use the latest added variant ID from the API response (index 0) or fallback to designId
  const variant_id =
    Array.isArray(wishListDesignIds) && wishListDesignIds.length > 0
      ? String(wishListDesignIds[0])
      : designId != null
        ? String(designId)
        : undefined;

  const wishlist_item_count_after =
    userInfo?.wishlistCount != null ? Number(userInfo.wishlistCount) : undefined;

  commonFacebookEventsUtil('AddToWishlist', {
    content_name: designName ?? '',
    content_category: designCategory ?? '',
    content_ids: designId != null && designId !== '' ? [String(designId)] : [],
    content_type: 'product',
    value: parsedPrice,
    currency: 'INR',
    variant_id,
    wishlist_item_count_after,
  });
}
